// import { useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
//   GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
//   GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
// } from "../../../../../Utils/Constant";
// import FormSelect from "../../../../../Lib/FormSelect";
// import FormInput from "../../../../../Lib/FormInput";

// const OrderItems = ({ orderItems, setOrderItems, isViewOnly = false }) => {
//   const dispatch = useDispatch();
//   const {
//     categoryList = [],
//     subCategoryList = [],
//     varientList = []
//   } = useSelector((state) => state.restaurant);

//   // Load all necessary data
//   useEffect(() => {
//     dispatch({ type: GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST });
//     dispatch({ type: GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST });
//     dispatch({ type: GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST });
//   }, [dispatch]);

//   // Memoize category options
//   const categoryOptions = useMemo(() => {
//     return categoryList?.data?.categories?.map((category) => ({
//       label: category.name,
//       value: category.id,
//     })) || [];
//   }, [categoryList]);

//   // Function to get subcategories for a specific category
//   const getSubCategoryOptions = useMemo(() => {
//     const allSubs = subCategoryList?.data?.subcategories || [];
//     return (categoryId) => {
//       if (!categoryId) return [];
//       return allSubs
//         .filter((sub) => String(sub.category_id) === String(categoryId))
//         .map((sub) => ({
//           label: sub.name,
//           value: sub.id,
//         }));
//     };
//   }, [subCategoryList]);

//   // Function to get variants for a specific subcategory
//   const getVariantOptions = useMemo(() => {
//     const allVariants = varientList?.data?.variants || [];
//     return (subcategoryId) => {
//       if (!subcategoryId) return [];
//       return allVariants
//         .filter((variant) => String(variant.subcategory_id) === String(subcategoryId))
//         .map((variant) => ({
//           label: variant.name,
//           value: variant.id,
//           price: variant.price,
//         }));
//     };
//   }, [varientList]);

//   // Handle quantity changes
//   const changeQuantity = (index, delta) => {
//     const updated = [...orderItems];
//     const currentQty = updated[index].quantity || 1;
//     const newQty = Math.max(1, currentQty + delta);
//     updated[index].quantity = newQty;
//     updated[index].total = updated[index].unit_price * newQty;
//     setOrderItems(updated);
//   };

//   // Handle field changes
//   const handleChange = (index, field, value) => {
//     const updated = [...orderItems];
//     updated[index][field] = value;

//     // Reset dependent fields when category changes
//     if (field === "category_id") {
//       updated[index].subcategory_id = "";
//       updated[index].variant_id = "";
//       updated[index].unit_price = 0;
//       updated[index].total = 0;
//     }

//     // Reset dependent fields when subcategory changes
//     if (field === "subcategory_id") {
//       updated[index].variant_id = "";
//       updated[index].unit_price = 0;
//       updated[index].total = 0;
//     }

//     // Set price when variant is selected
//     if (field === "variant_id") {
//       const selectedVariant = getVariantOptions(updated[index].subcategory_id)
//         .find(v => v.value === value);
//       if (selectedVariant) {
//         updated[index].unit_price = selectedVariant.price || 0;
//         updated[index].total = selectedVariant.price * (updated[index].quantity || 1);
//       }
//     }

//     // Recalculate total when quantity changes
//     if (field === "quantity") {
//       const unitPrice = updated[index].unit_price || 0;
//       updated[index].total = unitPrice * value;
//     }

//     setOrderItems(updated);
//   };

//   // Add a new order item
//   const addOrderItem = () => {
//     setOrderItems([
//       ...orderItems,
//       {
//         category_id: "",
//         subcategory_id: "",
//         variant_id: "",
//         quantity: 1,
//         unit_price: 0,
//         total: 0,
//         comment: ""
//       },
//     ]);
//   };

//   // Remove an order item
//   const removeOrderItem = (index) => {
//     const updatedItems = orderItems.filter((_, i) => i !== index);
//     setOrderItems(updatedItems);
//   };

//   return (
//     <div className="card mb-3">
//       <div className="card-header d-flex justify-content-between align-items-center">
//         <h5 className="card-title mb-0">Order Items</h5>
//         {!isViewOnly && (
//           <button type="button" className="btn btn-primary btn-sm" onClick={addOrderItem}>
//             <i className="bi bi-plus me-1"></i>Add Item
//           </button>
//         )}
//       </div>
//       <div className="card-body">
//         {orderItems.map((item, index) => (
//           <div key={index} className="border rounded p-3 mb-3">
//             <div className="row">
//               <div className="col-md-3 mb-2">
//                 <FormSelect
//                   label="Category"
//                   value={item.category_id || ""}
//                   onChange={(e) => handleChange(index, "category_id", e.target.value)}
//                   options={categoryOptions}
//                   required
//                   disabled={isViewOnly}
//                 />
//               </div>

//               <div className="col-md-3 mb-2">
//                 <FormSelect
//                   label="Dish Items"
//                   value={item.subcategory_id || ""}
//                   onChange={(e) => handleChange(index, "subcategory_id", e.target.value)}
//                   options={getSubCategoryOptions(item.category_id)}
//                   required
//                   disabled={!item.category_id || isViewOnly}
//                 />
//               </div>

//               <div className="col-md-3 mb-2">
//                 <FormSelect
//                   label="Variant"
//                   value={item.variant_id || ""}
//                   onChange={(e) => handleChange(index, "variant_id", e.target.value)}
//                   options={getVariantOptions(item.subcategory_id)}
//                   required
//                   disabled={!item.subcategory_id || isViewOnly}
//                 />
//               </div>
//               <div className="col-md-3 d-flex align-items-center justify-content-between gap-2">
//                 <div className=" mt-3 mb-0 d-flex align-items-center">
//                   {!isViewOnly ? (
//                     <div className="input-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary btn-sm"
//                         onClick={() => changeQuantity(index, -1)}
//                       >
//                         -
//                       </button>
//                       <input
//                         type="number"
//                         className="form-control text-center"
//                         min="1"
//                         value={item.quantity}
//                         onChange={(e) =>
//                           handleChange(index, "quantity", Math.max(1, parseInt(e.target.value) || 1))
//                         }
//                         disabled={isViewOnly}
//                       />
//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary btn-sm"
//                         onClick={() => changeQuantity(index, 1)}
//                       >
//                         +
//                       </button>
//                     </div>
//                   ) : (
//                     <span>{item.quantity}</span>
//                   )}
//                 </div>

//                 <div className="mt-3 d-flex align-items-end justify-content-between">
//                   <div className=" me-2" style={{ fontWeight: '600', fontSize: '0.9rem' ,marginLeft:'20px'}}>
//                     ₹{parseFloat(item.total ?? 0).toFixed(2)}
//                   </div>
//                   {!isViewOnly && (
//                     <button
//                       type="button"
//                       className="btn btn-outline-danger btn-sm"
//                       onClick={() => removeOrderItem(index)}
//                     >
//                       <i className="bi bi-trash"></i>
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="row mt-2">
//               {/* <div className="col-12">
//                 <FormInput
//                   label="Comment"
//                   type="text"
//                   placeholder="Special instructions..."
//                   value={item.comment || ""}
//                   onChange={(e) => handleChange(index, "comment", e.target.value)}
//                   readOnly={isViewOnly}
//                 />
//               </div> */}
//             </div>
//           </div>
//         ))}

//         {orderItems.length === 0 && (
//           <div className="text-center py-4 text-muted">
//             <i className="bi bi-cart-x fs-1 d-block mb-2"></i>
//             No items added yet.
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrderItems;



/////////////////////////////////////////////


"use client";

const OrderItems = ({ orderItems, setOrderItems, isViewOnly = false }) => {
  // Handle quantity changes
  const changeQuantity = (index, delta) => {
    const updated = [...orderItems];
    const currentQty = updated[index].quantity || 1;
    const newQty = Math.max(1, currentQty + delta);
    updated[index].quantity = newQty;
    updated[index].total = (parseFloat(updated[index].unit_price)+parseFloat(updated[index].variant_price || 0)) * newQty;
    setOrderItems(updated);
  };

  // Handle field changes
  const handleChange = (index, field, value) => {
    const updated = [...orderItems];
    updated[index][field] = value;

    // Recalculate total when quantity changes
    if (field === "quantity") {
      const unitPrice = updated[index].unit_price || 0;
      const varPrice = updated[index].unit_price || 0;
      updated[index].total = parseFloat(unitPrice)+parseFloat(varPrice) * value;
    }

    setOrderItems(updated);
  };

  // Remove an order item
  const removeOrderItem = (index) => {
    const updatedItems = orderItems.filter((_, i) => i !== index);
    setOrderItems(updatedItems);
  };

  return (
    <div className="card mb-3">
      <div className="card-header py-2">
        <h6 className="card-title mb-0">Order Items ({orderItems.length})</h6>
      </div>
      <div className="card-body p-3">
        {orderItems.map((item, index) => (
          <div key={index} className="border rounded p-3 mb-3 bg-light">
            {/* Item Header */}
            <div className="row mb-2">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 className="mb-1 text-primary fw-bold">{item.name}</h6>
                    <div className="d-flex gap-3 text-muted small">
                      <span>
                        <i className="fas fa-tag me-1"></i>
                        {item.category_name}
                      </span>
                      <span>
                        <i className="fas fa-cog me-1"></i>
                        {item.variant_name || 'regular'}
                      </span>
                    </div>
                  </div>
                  {!isViewOnly && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => removeOrderItem(index)}
                      title="Remove item"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Quantity and Price Controls */}
            <div className="row align-items-center">
              <div className="col-4">
                <label className="form-label small fw-semibold mb-1">
                  Quantity
                </label>
                {!isViewOnly ? (
                  <div className="input-group">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => changeQuantity(index, -1)}
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                    <input
                      type="number"
                      className="form-control form-control-sm text-center"
                      min="1"
                      value={item.quantity}
                      onChange={(e) =>
                        handleChange(
                          index,
                          "quantity",
                          Math.max(1, Number.parseInt(e.target.value) || 1)
                        )
                      }
                      disabled={isViewOnly}
                      style={{ maxWidth: "80px" }}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => changeQuantity(index, 1)}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </div>
                ) : (
                  <div className="form-control-plaintext fw-bold">
                    {item.quantity}
                  </div>
                )}
              </div>

              <div className="col-4">
                <label className="form-label small fw-semibold mb-1">
                  Unit Price
                </label>
                <div className="fw-bold text-success">
                  ₹{Number.parseFloat(item.unit_price ?? 0).toFixed(2)}
                </div>
              </div>
              {/* <div className="col-3">
                <label className="form-label small fw-semibold mb-1">
                  Variant Price
                </label>
                <div className="fw-bold text-success">
                  ₹{Number.parseFloat(item.variant_price ?? 0).toFixed(2)}
                </div>
              </div> */}

              <div className="col-4">
                <label className="form-label small fw-semibold mb-1">
                  Total
                </label>
                <div className="fw-bold text-primary h6 mb-0">
                  ₹{Number.parseFloat(item.total ?? 0).toFixed(2)}
                </div>
              </div>
            </div>

            {/* Additional Info */}
            <div className="row mt-2">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center text-muted small">
                  {/* <span>
                    <i className="fas fa-barcode me-1"></i>
                    Variant ID: {item.variant_id}
                  </span> */}
                  <span>
                    <i className="fas fa-calculator me-1"></i>
                    {item.quantity} × ₹
                    {Number.parseFloat(item.unit_price ?? 0).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}

        {orderItems.length === 0 && (
          <div className="text-center py-5 text-muted">
            <i className="fas fa-cart-plus fs-1 d-block mb-3 text-secondary"></i>
            <h6 className="mb-2">No items added yet</h6>
            <p className="mb-0 small">
              Click "Add" on menu items to add them to your order
            </p>
          </div>
        )}

        {/* {orderItems.length > 0 && (
          <div className="border-top pt-3 mt-3">
            <div className="row">
              <div className="col-6">
                <strong>Total Items : {orderItems.length}</strong>
              </div>
              <div className="col-6 text-end">
                <strong>
                  Subtotal: ₹
                  {orderItems
                    .reduce(
                      (sum, item) => sum + Number.parseFloat(item.total || 0),
                      0
                    )
                    .toFixed(2)}
                </strong>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default OrderItems;
